import { StructureSelectionRequest } from './../../../../../common/structure-selection/structure-selection.model';
import { MovementOrderStrategy, MovementOrderTargetStationStrategy, MovementOrderVehicleStrategy, Vehicle } from './../../movement-orders.model';
import { Component, OnInit, Inject } from '@angular/core';
import { MovementOrderDetails } from '../../movement-orders.model';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { StationGroup } from '../../../../../client/model/station-group';
import { StructureSelctionFilter, StructureSelection, StructureSelectionScope } from '../../../../../common/structure-selection/structure-selection.model';
import { UntypedFormControl as FormControl, UntypedFormGroup as FormGroup, Validators } from '@angular/forms';

@Component({
    selector: 'app-movement-order-strategy-dialog',
    templateUrl: './movement-order-strategy-dialog.component.html',
    styleUrls: ['./movement-order-strategy-dialog.component.scss'],
    standalone: false
})
export class MovementOrderStrategyDialogComponent implements OnInit {


  vehicleOptionsFormGroup = new FormGroup({});
  vehicleSelectionMode = 'automatically';

  confirmDialogEnabled = true;
  movementOrderDetails: MovementOrderDetails;

  stationGroups: Array<StationGroup>;
  selectedStationGroup: StationGroup = null;

  selection: StructureSelection;
  structureSelectionRequest: StructureSelectionRequest;

  selectedVehicleId: number;

  vehicleSelectionRequired = false;
  stationSelectionRequired = false;

  scope: StructureSelectionScope;

  constructor(
    private dialog: MatDialogRef<MovementOrderStrategyDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {
    this.movementOrderDetails = this.data.movementOrderDetails;
    this.vehicleSelectionRequired = this.movementOrderDetails.vehicleStrategy !== MovementOrderVehicleStrategy.FIXED;
    this.stationSelectionRequired = this.movementOrderDetails.targetStationStrategy !== MovementOrderTargetStationStrategy.FIXED;

    this.selection = new StructureSelection({ stationSetId: this.movementOrderDetails.targetStationSetId });

    this.structureSelectionRequest = new StructureSelectionRequest({
      scope: StructureSelectionScope.STATION,
      filter: StructureSelctionFilter.ANY,
	  fixedStationSetId: this.movementOrderDetails.targetStationSetId,
      selection: this.selection
    });
    this.vehicleOptionsFormGroup.addControl('vehicleSelectionMode', new FormControl(this.vehicleSelectionMode, [Validators.required]))
    this.vehicleOptionsFormGroup.valueChanges.subscribe(
      v => {
        this.vehicleSelectionMode = v.vehicleSelectionMode;
        if (this.vehicleSelectionMode === 'automatically') {
          this.selectedVehicleId = null;
        }
        this.updateEnablement();
      }
    );
    this.updateEnablement();
  }

  ngOnInit(): void {
  }

  public confirmDialog() {
    const result: MovementOrderStrategy = {
      targetStationId: this.selection.stationId,
      vehicleId: this.selectedVehicleId
    }
    this.dialog.close(result);
  }

  public selectedVehicleChanged(vehicleId: number) {
    this.selectedVehicleId = vehicleId;
    this.updateEnablement();
  }

  public cancelDialog() {
    this.dialog.close(null);
  }

  private updateEnablement() {
    let stationSelectionValid = true;
    if (this.stationSelectionRequired) {
      stationSelectionValid = this.selection?.valid && this.selection?.stationSetId === this.movementOrderDetails?.targetStationSetId
    }

    let vehicleSelectionValid = true;
    if (this.vehicleSelectionRequired && this.vehicleSelectionMode === 'manually') {
      vehicleSelectionValid = this.selectedVehicleId != null;
    }

    this.confirmDialogEnabled = stationSelectionValid && vehicleSelectionValid;
  }

  handleSelectionChanged(selection: StructureSelection) {
    this.selection = selection;
    this.updateEnablement();
  }
}
